'use client'

import React from 'react'
import { Heading } from '../heading'
import ReactMarkdown from 'react-markdown'

const MarkdownPreview = ({ content }: { content: string }): React.ReactElement => {
  return (
    <div>
      <Heading size="sm" weight="medium" className="mt-sm">
        Markdown preview
      </Heading>
      <ReactMarkdown
        className="bg-surface-container p-sm rounded-sm text-sm"
        disallowedElements={['img']}
        components={{
          h1: (props) => <Heading size="xl">{props.children}</Heading>,
          h2: (props) => <Heading size="lg">{props.children}</Heading>,
          h3: (props) => <Heading size="sm">{props.children}</Heading>,
          h4: (props) => <Heading size="xs">{props.children}</Heading>,
          ul: (props) => <ul className="mb-sm pl-md list-inside list-disc">{props.children}</ul>,
          ol: (props) => <ol className="mb-sm pl-md list-inside list-decimal">{props.children}</ol>
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}

export { MarkdownPreview }
